import * as betprofessor from './Action.styles.betprofessor';
import * as betroyale from './Action.styles.betroyale';
import * as fiestabet from './Action.styles.fiestabet';
import * as puntcity from './Action.styles.puntcity';
import * as puntgenie from './Action.styles.puntgenie';
import * as questbet from './Action.styles.questbet';
import * as sterlingparker from './Action.styles.sterlingparker';
import * as vikingbet from './Action.styles.vikingbet';
import * as volcanobet from './Action.styles.volcanobet';
import * as juicybet from './Action.styles.juicybet';
import * as goldenrush from './Action.styles.goldenrush';
import * as forsport from './Action.styles.forsport';
import * as junglebet from './Action.styles.junglebet';
import * as sugarcastle from './Action.styles.sugarcastle';
import * as oldgill from './Action.styles.oldgill';
import * as buffalobet from './Action.styles.buffalobet';
import * as betgalaxy from './Action.styles.betgalaxy';
import * as wellbet from './Action.styles.wellbet';
import * as titanbet from './Action.styles.titanbet';
import * as slambet from './Action.styles.slambet';
import * as gigabet from './Action.styles.gigabet';
import * as betstride from './Action.styles.betstride';
import * as templebet from './Action.styles.templebet';
import * as goldenbet888 from './Action.styles.goldenbet888';
import * as hyperbet from './Action.styles.hyperbet';
import * as bet777 from './Action.styles.bet777';
import * as chromabet from './Action.styles.chromabet';
import * as bet575 from './Action.styles.bet575';
import * as epicodds from './Action.styles.epicodds';
import * as pyramidbet from './Action.styles.pyramidbet';
import * as magnumbet from './Action.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  wellbet,
  betgalaxy,
  goldenrush,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  juicybet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
